import { ComponentStyleConfig, createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { selectAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle } = createMultiStyleConfigHelpers(selectAnatomy.keys);

const baseStyle = definePartsStyle({
  field: {
    color: 'text.main',
    borderColor: 'gray.500',
  },
  icon: {
    color: 'text.main',
  },
});

export const select: ComponentStyleConfig = {
  defaultProps: {
    focusBorderColor: 'gray.500',
  },
  baseStyle,
};
